function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext } from 'react';
import { connect, useSelector } from 'react-redux';
import { cmsActions } from '../../reducers/cms.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import ContactsData from './Contacts.context';
import AssetViewer from '../assets/AssetViewer.modal';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import Button from '../common/Button.react';
var ContactImage = function ContactImage(_ref) {
  var contactsAction = _ref.contactsAction,
    addModalAction = _ref.addModalAction;
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var _useContext = useContext(ContactsData),
    _useContext2 = _slicedToArray(_useContext, 1),
    form = _useContext2[0];
  var contactID = form.contactID,
    assetID = form.assetID;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Image"
  }), /*#__PURE__*/React.createElement(CardBody, null, !(assetID !== null && assetID !== void 0 && assetID._id) && /*#__PURE__*/React.createElement(Button, {
    label: "Select Image",
    permission: "edit-contacts",
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(AssetViewer, {
          onSelect: function onSelect(asset) {
            contactsAction({
              formData: {
                contactID: contactID,
                assetID: asset._id
              },
              method: 'put',
              route: 'image'
            });
          },
          type: "pageIndexContact"
        })
      });
    },
    style: {
      width: '100%',
      marginTop: 10
    }
  }), (assetID === null || assetID === void 0 ? void 0 : assetID._id) && /*#__PURE__*/React.createElement("img", {
    src: "".concat(bucket, "/").concat(assetID.filename),
    style: {
      width: 320
    }
  }), (assetID === null || assetID === void 0 ? void 0 : assetID._id) && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    icon: "lock-icon@3x.png",
    requireConfirmation: true,
    permission: "edit-contacts",
    onClick: function onClick() {
      contactsAction({
        formData: {
          contactID: contactID
        },
        method: 'delete',
        route: 'image'
      });
    }
  }))));
};
var mdtp = {
  addModalAction: modalActions.add,
  contactsAction: cmsActions.contacts
};
export default connect(null, mdtp)(ContactImage);